import type {PropsWithChildren} from 'react'

import styles from './Content.module.css'

export default function Content({children}: PropsWithChildren) {
  return <div className={styles.Content}>{children}</div>
}
